import { FC, useEffect } from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { usePageTitle } from 'hooks/usePageTitle';

import { Button } from 'components/parts/Button';
import Success from 'images/icon/success.svg';
import { useGetPrizeQuery, usePostPrizeMutation } from 'store/prize';

import styles from './PrizesCompleted.module.scss';

export const PrizesCompleted: FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const selectedPrizeType = id?.toUpperCase(); // SS | S | A | B | C | HAMADORI
  const getPrizeResult = useGetPrizeQuery(undefined, { skip: true });
  const [postPrize] = usePostPrizeMutation();

  usePageTitle('賞品');

  useEffect(() => {
    const postCompleted = async () => {
      if (selectedPrizeType) {
        await postPrize({ id: selectedPrizeType });
        await getPrizeResult.refetch();
      }
    };

    postCompleted();
  }, [postPrize, getPrizeResult, selectedPrizeType]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <div className={styles.body}>
          <img src={Success} alt="" className={styles.Icon} />
          <p className={styles.message}>賞品の応募完了！</p>
        </div>
        <div className={styles.foot}>
          <Button text="ホームに戻る" styleType="secondary" handleClick={() => navigate('/home')} />
        </div>
      </div>
    </div>
  );
};
